<template>
  <div class="s4s-provice"
  :style="show ? 'transform: translateY(0);opacity:1;' : 'transform: translateY(100%);opacity:0;'">
    <div style="overflow: hidden; padding-bottom: 60px;"
    :style="buttom ? 'padding-bottom: 60px;' : 'padding-bottom: 10px;'">
      <div
        v-for="(provice, index) in proviceList"
        :key="index"
        class="s4s-provice-tit"
        :style="provice == '隐藏' ? 'width: 33.899999999%;background: #BBC3C7;color: #fff;' : ''"
        @click="selProvince(provice)">{{provice}}
      </div>
    </div>
  </div>
</template>

<script>
/** ***
 *   <!-- 选择省份键盘 start -->
  <Provice :show="showProvice"
  @on-status-change="onProviceStatusChange"
  @on-result-change="onProviceResultChange"  />
  <!-- 选择省份键盘 end -->
 */
export default {
  data() {
    return {
      proviceList: [
        '京',
        '津',
        '渝',
        '沪',
        '冀',
        '晋',
        '辽',
        '吉',
        '黑',
        '苏',
        '浙',
        '皖',
        '闽',
        '赣',
        '鲁',
        '豫',
        '鄂',
        '湘',
        '粤',
        '琼',
        '川',
        '贵',
        '云',
        '陕',
        '甘',
        '青',
        '蒙',
        '桂',
        '宁',
        '新',
        '藏',
        '使',
        '领',
        '警',
        '学',
        '港',
        '澳',
        '隐藏',
      ],
      result: this.show,
    };
  },
  props: {
    show: {
      type: Boolean,
      default: false,
      required: true,
    },
    buttom: {
      type: Boolean,
      default: true,
    },
  },
  watch: {
    show(val) {
      this.result = val;
    },
    result(val) {
      this.$emit('on-status-change', val);
    },
  },
  mounted() {

  },
  methods: {
    selProvince(val) {
      if (val === '隐藏') {
        this.$emit('on-status-change', false);
      } else {
        this.$emit('on-result-change', val);
        this.$emit('on-status-change', false);
      }
    },
  },
};
</script>

<style  lang="scss" scoped>
.s4s-provice{
  user-select: none;
  width: 100%;
  background: #D8DBDC;
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 999;
  transform: translateY(100%);
  transition: all .3s ease-out;
}
.s4s-provice-tit{
  font-size: 16px;
  float: left;
  width: 9%;
  padding: 10px 0;
  background: #fff;
  border-radius: .03rem;
  margin-left: 3.09999999%;
  margin-top: 3.09999999%;
  text-align: center;
}
.s4s-provice-tit:hover{
  background: #bbb !important;
  color: #fff !important;
}
</style>
